<template>
  <v-card :style="cardStyle" elevation="2" :loading="isLoading">
    <v-card-title id="title-bar" ref="cardTitle" v-if="showTitlebar">
      <!-- <v-btn
        color="error"
        v-if="showBackButton"
        style="margin-right: 10px"
        :to="{ name: 'dashboard' }"
        elevation="2"
      >
        <v-icon>mdi-arrow-left</v-icon> Indietro
      </v-btn> -->
      <v-spacer></v-spacer> {{ title }}<v-spacer></v-spacer>

      <v-btn @click="showOptionsD = !showOptionsD" elevation="2" icon>
        <v-icon>mdi-filter-outline</v-icon>
      </v-btn>
      <v-btn v-on:click="fullscreen = !fullscreen" elevation="2" icon>
        <v-icon v-if="!fullscreen">mdi-fullscreen</v-icon>
        <v-icon v-if="fullscreen">mdi-fullscreen-exit</v-icon>
      </v-btn>
    </v-card-title>
    <CustomCalendar
      ref="calendar"
      v-bind:height="maxTableHeight"
      v-bind:items="resources"
      @periodChanged="loadEvents()"
      item-key="idRisorsa"
      item-text="descrizione"
      
      :loading="true"
      items-header="Operatori"
      v-bind:events="events"
      event-item-key="idRisorsa"
      :showOptions="showOptionsD"
      :showToolbar="showToolbar"
      v-bind:labels="[
        'Domenica',
        'Lunedì',
        'Martedì',
        'Mercoledì',
        'Giovedì',
        'Venerdì',
        'Sabato',
      ]"
      v-bind:days-to-show="UISettings.planner.daysToShow"
      :max-days-to-show="UISettings.planner.maxDaysToShow"
      :fit-max-days-visible="UISettings.planner.fitVisibleDays"
      :start-from-today="UISettings.planner.startFromToday"
      v-bind:actions="actions"
    >
      <template #cell-content="props">
        <CellEvent
          :events="getEvents(props.date, props.item)"
          :selectedItems="selectedItems"
          :isChecked="isChecked(props.item)"
          :selectable="
            (props.date.date == selectedDay.date &&
              selectionMode == SelectionMode.ROWS) ||
            (props.item.idRisorsa ==
              (selectedItem != null ? selectedItem.item.idRisorsa : '') &&
              selectionMode == SelectionMode.COLUMNS)
          "
          :item="createItem(props.date, props.item)"
          :date="props.date"
          :showCellHover="showCellHover"
          :allowDragAndDrop="allowDragAndDropEvents "
          @cellClick="CellClick"
          @absenceClick="AbsenceClick"
          
          @eventClick="EventClick"
          @eventMoved="EventMoved"
          @eventCloned="EventCloned"
        >
        </CellEvent>
      </template>
    </CustomCalendar>

    <v-dialog v-model="EditEventDialog" width="1000">
      <v-card>
        <FrmNewEvent
          v-bind:evento="event"
          v-on:eventAdded="event_Added"
          v-on:eventAdding="event_Adding"
          v-on:eventUpdated="event_Updated"
        ></FrmNewEvent>
      </v-card>
    </v-dialog>

    <v-dialog v-model="AbsenceEventDialog" width="1000">
      <v-card>
        <FrmNewAbsence
          v-bind:evento="event"
          v-bind:selectedDays="selectedDays"
          v-on:eventAdded="event_Added"
          v-on:eventUpdated="event_Updated"
        ></FrmNewAbsence>
      </v-card>
    </v-dialog>
    <SelectDialog ref="selectDialog"></SelectDialog>
    <CustomDialog ref="dialog"></CustomDialog>
    <v-snackbar v-model="ShowSnackbar" :timeout="5000">
      {{ error }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error = ''">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="showEventDetailsModal" max-width="600px">
      <!-- <v-card>
        <v-card-title> Dati evento </v-card-title>
        <v-card-text>
          <p>Data:{{ moment(this.event).format("DD/MM/YYYY") }}</p>
          <p>Giornata intera:{{ this.event.giornoIntero ? "SI" : "NO" }}</p>
          <p v-if="!this.event.giornoIntero">
            Ora:{{ moment(this.event).format("DD/MM/YYYY") }}
          </p>
        </v-card-text>
      </v-card> -->
      <EventInfoModal v-bind:evento="event" ref="eventModal"> </EventInfoModal>

      <v-card>
        <v-card-actions>
          <v-btn color="primary" text @click="showEventDetailsModal = false">
            Chiudi
          </v-btn>
          <v-btn
            v-if="(isEventCreatorP || canEditOtherUserEvents()) && event.tipo != EventType.Assenza"
            color="success"
            text
            @click="btnEditEvent_Click"
          >
            Modifica
          </v-btn>
          <v-btn
            color="orange"
            text
            @click="btnChangeEventOwner_Click"
            v-if="canChangeEventOwner"
          >
            Riassegna
          </v-btn>

          <v-btn
            color="error"
            text
            @click="btnRemoveEvent_Click"
            v-if="isEventCreatorP"
          >
            Rimuovi
          </v-btn>
        </v-card-actions>
      </v-card>
      <SelectDialog ref="selectNewEventOwner"> </SelectDialog>
      <SelectDialog ref="selectAbsenceReason"> </SelectDialog>
    </v-dialog>
  </v-card>
</template>


<style lang="scss">
.v-btn.event-button {
  padding: 0px !important;
  display: block !important;
  height: 100% !important;
  width: 100% !important;
  color: whitesmoke;
}
button.v-btn.event-button.empty-event:hover {
  background: #1976d2 !important;
}
#title-bar {
  padding: 6px;
}
.drop-zone {
  height: 100%;
}
.blink {
  animation: blinker 1s ease infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.7;
  }
}
.i-table[isselected=true]:hover {
    background: #88cce0;
}
</style>


<script>
import moment, { normalizeUnits, suppressDeprecationWarnings } from "moment";
import CustomCalendar from "../CustomComponentsUI/CustomCalendar";
import CellEvent from "../CustomComponentsUI/CellEvent";
import CustomDialog from "../CustomComponentsUI/CustomDialog";
import SelectDialog from "../CustomComponentsUI/SelectDialog";
import FrmNewEvent from "../FrmNewEvent/FrmNewEvent";
import FrmNewAbsence from "../FrmNewEvent/FrmNewAbsence.vue";
import EventInfoModal from "./EventInfoModal";
import EasyPlanClient from "../../utils/EasyPlanClient";
import EventType from "../../settings/EventType"; 
import StepEmailUsernameVue from "../FrmRecoverPassword/Steps/StepEmailUsername.vue";
import Vue from "vue"
import FrmPlanner from "./FrmPlanner.ts"

export default  Vue.extend(FrmPlanner);
</script>